import { social } from '@/lib/config'

export const CLINIC_ID = 'https://elemental.ae/#clinic'
export const SITE_ORIGIN = 'https://elemental.ae'

const SAME_AS_NETWORKS = new Set(['youtube', 'facebook', 'instagram', 'linkedin', 'doctify','wiki'])
const GOOGLE_MAPS_PLACE_ID = 'ChIJbRitGv9DXz4RxI3UUp4hA3g'
const GOOGLE_MAPS_URL = `https://maps.google.com/?cid=8647792673359695300`

export const CLINIC = {
  name: 'ELEMENTAL Day Surgical Center',
  url: SITE_ORIGIN,
  logo: `${SITE_ORIGIN}/images/logo.jpeg`,
  image: `${SITE_ORIGIN}/images/logo.jpeg`,
  telephone: '+97143830500',
  email: 'info@elemental.ae',
  priceRange: '$$',
  isAcceptingNewPatients: true,
  dhaLicense: '5323888',
  foundingDate: '2026',
  address: {
    streetAddress: '113 Jumeirah St., Jumeirah 1',
    addressLocality: 'Dubai',
    addressCountry: 'AE',
  },
  // Coordinates used by the on-site Google Map (ContactsMap)
  geo: {
    latitude: 25.22480998961149,
    longitude: 55.25822724062945,
  },
  hasMap: GOOGLE_MAPS_URL,
  sameAs: [
    ...social.filter((item) => SAME_AS_NETWORKS.has(item.name)).map((item) => item.sameAs || item.href),
    GOOGLE_MAPS_URL,
  ],
}

export const MEDICAL_SPECIALTIES = [
  'Anesthesia',
  'Cardiovascular',
  'CommunityHealth',
  'Dentistry',
  'Dermatology',
  'DietNutrition',
  'Emergency',
  'Endocrine',
  'Gastroenterologic',
  'Genetic',
  'Geriatric',
  'Gynecologic',
  'Hematologic',
  'Infectious',
  'LaboratoryScience',
  'Midwifery',
  'Musculoskeletal',
  'Neurologic',
  'Nursing',
  'Obstetric',
  'Oncologic',
  'Ophthalmology',
  'Optometric',
  'Otolaryngologic',
  'Pathology',
  'Pediatric',
  'PharmacySpecialty',
  'Physiotherapy',
  'PlasticSurgery',
  'Podiatric',
  'PrimaryCare',
  'Psychiatric',
  'PublicHealth',
  'Pulmonary',
  'Radiography',
  'Renal',
  'RespiratoryTherapy',
  'Rheumatologic',
  'SpeechPathology',
  'Surgical',
  'Toxicologic',
  'Urologic',
]

export const MEDICAL_SPECIALTY_ALIASES = [
  { specialty: 'Ophthalmology', keywords: ['oculoplastic', 'ophthalm'] },
  { specialty: 'PlasticSurgery', keywords: ['plastic', 'face', 'breast', 'body'] },
  { specialty: 'Anesthesia', keywords: ['anesth', 'anaesthes'] },
  { specialty: 'Cardiovascular', keywords: ['vascular', 'cardio', 'phleb'] },
  { specialty: 'Dermatology', keywords: ['dermatolog', 'cosmetolog', 'aesthetic'] },
  { specialty: 'Dentistry', keywords: ['dentistr', 'dental', 'stomat'] },
  { specialty: 'LaboratoryScience', keywords: ['laborat'] },
  { specialty: 'Gastroenterologic', keywords: ['endoscop', 'gastro'] },
  { specialty: 'Gynecologic', keywords: ['gynecol', 'gynaecol'] },
  { specialty: 'Urologic', keywords: ['urolog'] },
  { specialty: 'Neurologic', keywords: ['neurolog'] },
  { specialty: 'Pediatric', keywords: ['pediatric', 'paediatric'] },
  { specialty: 'Otolaryngologic', keywords: ['otolaryng'] },
  { specialty: 'Oncologic', keywords: ['oncolog'] },
  { specialty: 'Psychiatric', keywords: ['psychiatr'] },
  { specialty: 'Physiotherapy', keywords: ['physio'] },
  { specialty: 'Surgical', keywords: ['surg', 'proctolog', 'coloproct'] },
]

export const PROCEDURE_TYPES = new Set([
  'SurgicalProcedure',
  'TherapeuticProcedure',
  'DiagnosticProcedure',
])
